export const subtitles = {
    "1": {
        "startTime": 6.28,
        "endTime": 8.73,
        "transcript": "Ai? (Tangiqgngatellruuq.)",
        "translation": "What? (It looked bright.)"
    },
    "2": {
        "startTime": 9.06,
        "endTime": 12.62,
        "transcript": "Ayagceteksaitan-qaa? (Yaa, uitaqaa.)",
        "translation": "You haven't started it yet? (Yes, wait.)"
    },
    "3": {
        "startTime": 12.625,
        "endTime": 25.595,
        "transcript": "Kitak' ayagceskuvgu apeskia qaill' uksuarmi up'ngelauciit atu'urkameggnek.",
        "translation": "Okay, when you start it, ask me about how they prepare what they need to use in the fall."
    },
    "4": {
        "startTime": 30.095,
        "endTime": 31.91,
        "transcript": "Tuaten aqumgaciquten?",
        "translation": "Will you be sitting like that?"
    },
    "5": {
        "startTime": 31.91,
        "endTime": 35.0,
        "transcript": "Ii-i, waten aqumgaurciqua. (Ii-i.)",
        "translation": "Yes, I'll be sitting like this. (Okay.)"
    },
    "6": {
        "startTime": 41.04,
        "endTime": 46.88,
        "transcript": "Kitak' qaillun up'ngelallruat waten uksumi?",
        "translation": "So, how did they prepare in the winter like this?"
    },
    "7": {
        "startTime": 47.535,
        "endTime": 56.49,
        "transcript": "Waten-qaa uksuarmi up'ngelallrit au͡gkut?",
        "translation": "You mean how people back then would start preparing in the fall?"
    },
    "8": {
        "startTime": 56.49,
        "endTime": 57.49,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "9": {
        "startTime": 58.565,
        "endTime": 61.52,
        "transcript": "Au͡gkut ciuqlimta?",
        "translation": "Our ancestors?"
    },
    "10": {
        "startTime": 61.52,
        "endTime": 62.49,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "11": {
        "startTime": 63.31,
        "endTime": 74.7,
        "transcript": "Tua-i-llu wiinga waniw' ak'allauqapiaraunritua.",
        "translation": "So, I am not very old right now."
    },
    "12": {
        "startTime": 75.52,
        "endTime": 83.47,
        "transcript": "Tau͡gaam maa-i allrakunka 68-aarurrluteng.",
        "translation": "But now, I am 68 years old."
    },
    "13": {
        "startTime": 86.04,
        "endTime": 88.93,
        "transcript": "Tuntutuliarmiungulua.",
        "translation": "I'm from Tuntutuliak."
    },
    "14": {
        "startTime": 89.49,
        "endTime": 94.7,
        "transcript": "Yugtun-llu atengqerrlua Ackiarmek pilallruatnga.",
        "translation": "And they would call me Ackiar in Yup'ik."
    },
    "15": {
        "startTime": 94.85,
        "endTime": 100.85,
        "transcript": "Tua-i-ll' Kassaurcamta maa-i Nick Lupie-mek pilanglua.",
        "translation": "Then after Westernization, they've started calling me Nick Lupie."
    },
    "16": {
        "startTime": 101.195,
        "endTime": 111.505,
        "transcript": "Tua-i-llu ava-i aptuten uksuarmi up'ngelallritnek",
        "translation": "And so, you just asked how they started preparing in the fall"
    },
    "17": {
        "startTime": 111.505,
        "endTime": 121.805,
        "transcript": "Wall'u uksum-wa tua-i atu'urkainek up'ngelallritnek.",
        "translation": "Or how they started preparing what they'd need to use in the winter."
    },
    "18": {
        "startTime": 122.07,
        "endTime": 132.63,
        "transcript": "Wii tua-i nallunrilkemnek tangvallemnek-llu, yaa, waniw' qanengssakatartua.",
        "translation": "Now, I'm going to speak, yes, about what I know and what I've seen."
    },
    "19": {
        "startTime": 133.025,
        "endTime": 141.895,
        "transcript": "Waten uksuarmi qavani Kialirmi tan'gaurluullemteńi",
        "translation": "In the fall upriver in Kialiq when we were boys"
    },
    "20": {
        "startTime": 142.085,
        "endTime": 148.995,
        "transcript": "Kiani Kialiim paingani Qukaqlircaramek-gguq uumek aterluni kuiggaq au͡gna.",
        "translation": "Upriver at the mouth of Kialiq, they called that stream Qukaqlircaraq."
    },
    "21": {
        "startTime": 149.125,
        "endTime": 153.575,
        "transcript": "Tuani tua-i uitalallruukut.",
        "translation": "We used to stay there."
    },
    "22": {
        "startTime": 154.305,
        "endTime": 164.835,
        "transcript": "Makut tau͡gken aulukesteput waten uksuarmi uitaurallrunritut.",
        "translation": "Our caretakers, however, were not sedentary in the fall like this."
    },
    "23": {
        "startTime": 166.445,
        "endTime": 173.745,
        "transcript": "Wall'u cali uitaurluteng waten ayagayuitellruluteng.",
        "translation": "Or, they also didn't travel without physical labor."
    },
    "24": {
        "startTime": 174.31,
        "endTime": 186.44,
        "transcript": "Makut maa-i uksuarmun atulriit waten agaaken neqlillernek taigaqameng",
        "translation": "These things they used for the fall, when they came from the fish camps across there like this"
    },
    "25": {
        "startTime": 186.56,
        "endTime": 193.48,
        "transcript": "Uksuarmi muragnek quyurtetullruut.",
        "translation": "They would gather wood in the fall."
    },
    "26": {
        "startTime": 193.895,
        "endTime": 198.625,
        "transcript": "Angyaunateng-llu tau͡gaam qayatgun.",
        "translation": "And they didn't have boats, only kayaks."
    },
    "27": {
        "startTime": 198.955,
        "endTime": 206.485,
        "transcript": "Unuakumi waten uksuarmi ulerpagangetuan",
        "translation": "Because there is a very high tide in the morning during the fall like this"
    },
    "28": {
        "startTime": 206.805,
        "endTime": 213.715,
        "transcript": "Unuakuarmi tan'germi tayima ayagangtullruut.",
        "translation": "They would start traveling early in the morning in the dark."
    },
    "29": {
        "startTime": 214.165,
        "endTime": 226.045,
        "transcript": "Tua-i tau͡gken iliini uaggun Cingigkun igvarnaurtuq iliini qayaq nangcarluni muragnek.",
        "translation": "Sometimes, however, a kayak would appear coming through Cingik downriver towing wood."
    },
    "30": {
        "startTime": 228.234,
        "endTime": 242.142,
        "transcript": "Tua-i tamaa-i tamakut waten uksuarmi maavet kuiget kangritnun ayakata'arqameng uksuiyaqatarqameng",
        "translation": "In the fall like this, when they were going to travel here to the headwaters of the rivers to go to winter camps"
    },
    "31": {
        "startTime": 242.923,
        "endTime": 246.956,
        "transcript": "Tamakunek tamaa-i quyurtetullruut.",
        "translation": "They would gather those."
    },
    "32": {
        "startTime": 249.089,
        "endTime": 259.033,
        "transcript": "Au͡gkut ciuqliput anglicarteput wangkucicetun maanitun ayuqellrunritut.",
        "translation": "Our elders, those who raised us, were not like how we are now."
    },
    "33": {
        "startTime": 259.412,
        "endTime": 270.954,
        "transcript": "Ellmeggnek ang'aqualuteng tallimegteggun ayagaluteng merkun anguarturluteng pitullruut.",
        "translation": "They would travel, rowing with their own arms, rowing through the water."
    },
    "34": {
        "startTime": 271.312,
        "endTime": 282.475,
        "transcript": "Tua-i-llu nutaan pinarilliateng asgurangluteng.",
        "translation": "Then when it was time for them, they started going upriver."
    },
    "35": {
        "startTime": 283.141,
        "endTime": 288.263,
        "transcript": "Imkut tamakut muriit itulluki.",
        "translation": "They brought those pieces of wood with them."
    },
    "36": {
        "startTime": 290.34,
        "endTime": 296.918,
        "transcript": "Nutaan-llu qaingit canek ucilirluki aklumeggnek.",
        "translation": "Then they would put their possessions as cargo on top of them."
    },
    "37": {
        "startTime": 297.248,
        "endTime": 302.448,
        "transcript": "Angyailnguut muragteggun tua-i upatullruut.",
        "translation": "Those without boats would move with wood."
    },
    "38": {
        "startTime": 303.132,
        "endTime": 313.788,
        "transcript": "Tua-i-llu nutaan tekicameng kuiget kangritnun tamaavet uksuillerkameggnun muriit tamakut tageqluki.",
        "translation": "Then when they arrived at the headwaters of the rivers where they would camp for the winter, they would bring the wood inland."
    },
    "39": {
        "startTime": 313.885,
        "endTime": 328.819,
        "transcript": "Nutaan-llu upluteng muriit tamakut neqsuutekateng taluyarkateng upluki.",
        "translation": "Then they would prepare that wood, preparing their fish traps to catch fish with."
    },
    "40": {
        "startTime": 332.4,
        "endTime": 340.395,
        "transcript": "Anglicarteput au͡gkut nangtequaluteng pitullruut.",
        "translation": "Those who raised us back then lived hard lives."
    },
    "41": {
        "startTime": 341.113,
        "endTime": 347.991,
        "transcript": "Muriit imkut taluyarkiurluki, taluyarpagkiurluki pitullruit.",
        "translation": "They would make that wood into fish traps, large fish traps."
    },
    "42": {
        "startTime": 348.873,
        "endTime": 359.746,
        "transcript": "Waten taluyarpiit ayuqetullruut paingit iqtuluteng, takluteng.",
        "translation": "The openings of those large fish traps were like this, wide and long."
    },
    "43": {
        "startTime": 361.611,
        "endTime": 369.889,
        "transcript": "Waten-llu tua-i piluteng ayuqluteng, wagg'uq taukut tua-i ilulirpait.",
        "translation": "And they were like this, the inner components they called ilulirpiit."
    },
    "44": {
        "startTime": 369.922,
        "endTime": 378.511,
        "transcript": "Nutaan-llu ukut cali qukait cali taluyiluki waten qerrurluki.",
        "translation": "Then they would make the middle of the fish traps by expanding them."
    },
    "45": {
        "startTime": 378.577,
        "endTime": 384.377,
        "transcript": "Nutaan-llu yaaggun pingayuat piluku.",
        "translation": "Then they would place the third over there."
    },
    "46": {
        "startTime": 384.888,
        "endTime": 392.261,
        "transcript": "Tamakut tamaa-i qamunek pitullruit taluyapiat.",
        "translation": "They referred to those real fish traps as qamut."
    },
    "47": {
        "startTime": 392.391,
        "endTime": 400.18,
        "transcript": "Makut taluyarpiit pitun, can'giircuutetun ayuqellrunritut.",
        "translation": "These big fish traps were not like, you know, traps for blackfish."
    },
    "48": {
        "startTime": 400.291,
        "endTime": 406.78,
        "transcript": "Waten-llu akultutaluteng, akultutarrluki.",
        "translation": "And they had gaps of this size, made them with gaps of this size."
    },
    "49": {
        "startTime": 408.185,
        "endTime": 413.119,
        "transcript": "Yaa, piciatun-am pivkenaki tamakut taluyarpiit pitullruit.",
        "translation": "Yes, they didn't make those large fish traps without a process."
    },
    "50": {
        "startTime": 413.326,
        "endTime": 417.948,
        "transcript": "Waten ukut cuq'errluki.",
        "translation": "They used these as measurements."
    },
    "51": {
        "startTime": 418.311,
        "endTime": 424.533,
        "transcript": "Tua-i-llu imna cigyak elliluku, tuavet elliluku.",
        "translation": "And then they would put the split spruce there."
    },
    "52": {
        "startTime": 424.541,
        "endTime": 434.952,
        "transcript": "Tua-i-ll' waten nutaan pirraarluku yaatiinun qaill' tua-i waten akultutarrluki tamakut taluyarpiit pitullruit.",
        "translation": "Then after doing this, they would make those large fish traps with about this size gaps to the side."
    },
    "53": {
        "startTime": 437.037,
        "endTime": 448.604,
        "transcript": "Tua-i waten caliaqengaqamegteki unatmeggnek-llu nangutetullruut makut, ukut waten piurallrit.",
        "translation": "When they started working on them like this, their hands would get raw from doing this."
    },
    "54": {
        "startTime": 449.9,
        "endTime": 460.956,
        "transcript": "Pelacignagnek piyuunaki, tau͡gaam makunek cali muragnek qupurturluki amililuki, mamkunaki.",
        "translation": "They wouldn't use twine, but they split wood like this until they were thin in diameter, thin."
    },
    "55": {
        "startTime": 460.999,
        "endTime": 466.944,
        "transcript": "Qaillun tua-i waten iqtutaurluki, tau͡gaam amililuki.",
        "translation": "They would make them about this wide, but thin."
    },
    "56": {
        "startTime": 467.158,
        "endTime": 471.566,
        "transcript": "Tamakut-am tua-i piciatun cali caliaqsuitellruit.",
        "translation": "They wouldn't work on those without a process either."
    },
    "57": {
        "startTime": 471.577,
        "endTime": 476.888,
        "transcript": "Cuqerluteng qaillun mamtutacirkait.",
        "translation": "They had measurements of how thick to make them."
    },
    "58": {
        "startTime": 478.952,
        "endTime": 487.319,
        "transcript": "Tuaten tua-i pingaqameng makuit nangtullruut, ukut waten piurluki.",
        "translation": "When they started doing that, these got raw from doing this."
    },
    "59": {
        "startTime": 488.406,
        "endTime": 500.395,
        "transcript": "Aunrangaqata tua-i imkunek qecignek caquliluki ukut pingayun pitullruit",
        "translation": "When they started bleeding, they would cover these three with skin"
    },
    "60": {
        "startTime": 501.104,
        "endTime": 504.216,
        "transcript": "Nang'aqata makut.",
        "translation": "When these got raw."
    },
    "61": {
        "startTime": 505.831,
        "endTime": 511.576,
        "transcript": "Ukut-llu cali, ukut-llu nang'aqluteng tegumiaqurallrit.",
        "translation": "These too, these would get raw from holding it."
    },
    "62": {
        "startTime": 512.964,
        "endTime": 520.031,
        "transcript": "Au͡gkut ciuqliput watua wangkucicetun waten ayuqellrunritut.",
        "translation": "Our ancestors back then were not like how we are now."
    },
    "63": {
        "startTime": 520.552,
        "endTime": 526.747,
        "transcript": "Aklungqellruut, muragnek aklungqellruut.",
        "translation": "They had wooden possessions."
    },
    "64": {
        "startTime": 526.756,
        "endTime": 532.923,
        "transcript": "Tamaa-i tamakut aklukellruit muriit.",
        "translation": "They used wood to make their possessions."
    },
    "65": {
        "startTime": 532.935,
        "endTime": 545.924,
        "transcript": "Cassuutekluki, cakluki, enekluki, enemeggnun waten aklukluki, ikamraqluki-llu.",
        "translation": "They used it for their tools, their things, their houses, what they had in their houses, and sleds."
    },
    "66": {
        "startTime": 546.354,
        "endTime": 553.932,
        "transcript": "Tua-i cat aturluku una murak yuungnaqellruut, muriit.",
        "translation": "They used this wood for survival."
    },
    "67": {
        "startTime": 557.85,
        "endTime": 572.7,
        "transcript": "Tua-i tau͡gken cali civcimariaqamegteki nutaan waten unuaquaqan takuurluki.",
        "translation": "However, when they started setting them, they would check on them every day like this."
    },
    "68": {
        "startTime": 575.513,
        "endTime": 581.874,
        "transcript": "Unuakumi-llu cali uicara'arluteng ullraarluni entaqan",
        "translation": "And they would wake up in the morning when the tide had gone out after coming in"
    },
    "69": {
        "startTime": 584.012,
        "endTime": 598.808,
        "transcript": "Unugmi tua-i makluteng imkut neqsuuteteng kapuyutait atrarluteng menglait waten tugqerraarluki kaputkaniraqluki.",
        "translation": "They would get up at night, go down to the stakes of the fishing tools, and stick them further in after chiseling the ice like this."
    },
    "70": {
        "startTime": 599.767,
        "endTime": 610.7,
        "transcript": "Au͡gkut ava-i waten aulukesteput ayuqellruut, mat'um nalliinitun ayuqevkenateng.",
        "translation": "This is how our caretakers were back then, not like now."
    },
    "71": {
        "startTime": 611.727,
        "endTime": 626.191,
        "transcript": "Tua-i-llu nutaan uksuarmi tuaten tua-i pian makut cali arnaita aklukaitnek upluki atu'urkaitnek.",
        "translation": "Then when fall came like that, they would also prepare things for their women to use."
    },
    "72": {
        "startTime": 629.275,
        "endTime": 642.202,
        "transcript": "Makunek tua-i imkunek neqnek, taryaqviit-llu qeciitnek wagg'uq amiraliluki.",
        "translation": "They made what they called waterproof fish skin boots out of fish skin, including king salmon."
    },
    "73": {
        "startTime": 642.22,
        "endTime": 646.409,
        "transcript": "Amiragnek tamakut pitullruit neqet qeciit.",
        "translation": "They referred to fish skins as amiriit."
    },
    "74": {
        "startTime": 646.911,
        "endTime": 648.366,
        "transcript": "Kitak' uitaqaa.",
        "translation": "Hold on for a moment."
    },
    "75": {
        "startTime": 662.292,
        "endTime": 665.866,
        "transcript": "Kitak' nutaan.",
        "translation": "Please start again."
    },
    "76": {
        "startTime": 666.52,
        "endTime": 668.642,
        "transcript": "Ayagnirnariuq? Ii-i.",
        "translation": "It's time to start? Okay."
    },
    "77": {
        "startTime": 668.662,
        "endTime": 684.899,
        "transcript": "Ava-i au͡gna, au͡gkut ava-i waten qanengssakellrenka angutet caliarit, angutet calilallrit aklumeggnek upluteng pillrit.",
        "translation": "Just now, I talked about men's work, how men worked to prepare their things."
    },
    "78": {
        "startTime": 685.312,
        "endTime": 697.374,
        "transcript": "Tau͡gken cali makut arnat allakarmeng waten cikuvailgan-llu uptenglallruit anguteteng.",
        "translation": "However, women would work separately before it froze to prepare things for their men."
    },
    "79": {
        "startTime": 697.537,
        "endTime": 711.687,
        "transcript": "Atu'urkaitnek, pilugugkaitnek, makunek-llu cali waten neqet qeciitnek, taryaqvagnek",
        "translation": "Clothes they would need, skin boots, and these fish skins, king salmon"
    },
    "80": {
        "startTime": 712.544,
        "endTime": 720.656,
        "transcript": "Apeqmeggnek-gguq neqairiluteng, tuaten pitullruut amirarkiurqamegteki.",
        "translation": "They called it \"removing fish\" when they made fish skin boots for them."
    },
    "81": {
        "startTime": 720.907,
        "endTime": 732.119,
        "transcript": "Cali-am tamakut waten tua-i kemgit au͡g'aqainarraarpek'naki",
        "translation": "Also, with those, they wouldn't just stop at removing their flesh"
    },
    "82": {
        "startTime": 732.195,
        "endTime": 742.457,
        "transcript": "Taqngamegteki tamakut kemgit au͡gaumariaqata egmianun cali caliaqevkenaki.",
        "translation": "When they finished removing their flesh, they wouldn't work on them right away."
    },
    "83": {
        "startTime": 742.808,
        "endTime": 758.595,
        "transcript": "Waten cali teq'umun akurrluki pitullruit tamakut neqet qeciit neqcugniirulluki.",
        "translation": "They would also soak the fish skins in urine like this to remove the fishy smell."
    },
    "84": {
        "startTime": 758.945,
        "endTime": 766.02,
        "transcript": "Makut maa-i waten wagg'uq teqiciriaqameng",
        "translation": "They say  that when they aged urine"
    },
    "85": {
        "startTime": 767.701,
        "endTime": 782.639,
        "transcript": "Cat canun tua-i assigtaitnun, nutem assigtaitnun angutait tamaavet qurrmatullruut, wagg'uq teq'iciriluteng.",
        "translation": "Into some containers, the men would urinate into the designated containers to age urine, as they called it."
    },
    "86": {
        "startTime": 782.652,
        "endTime": 786.389,
        "transcript": "Tua-i tepsaqnaurtut tamakut cakneq.",
        "translation": "Those would smell very strong."
    },
    "87": {
        "startTime": 786.789,
        "endTime": 794.389,
        "transcript": "Tua-i tamakunun akurrluki tamakut neqet qeciit pitullruit.",
        "translation": "They would soak the fish skins in those."
    },
    "88": {
        "startTime": 794.583,
        "endTime": 805.346,
        "transcript": "Nutaan-llu tua-i akungqarraarluki keligarluki, keligaucirluki ayallanun pirraarluki.",
        "translation": "Then after soaking them, they would scrape them, scrape them after putting them on boards."
    },
    "89": {
        "startTime": 805.358,
        "endTime": 812.096,
        "transcript": "Nutaan ellamun agarrluki kinercirluki.",
        "translation": "Then they would hang them outside to dry."
    },
    "90": {
        "startTime": 812.134,
        "endTime": 825.409,
        "transcript": "Tua-i-llu nutaan kinraki tamakut tamaa-i tamakunun angutmeggnun piluguliluki.",
        "translation": "And then when they dried, they would make them into skin boots for their men."
    },
    "91": {
        "startTime": 825.415,
        "endTime": 830.69,
        "transcript": "Wagg'uq amiraliluki waten ayagassuucirluki.",
        "translation": "They called it making them fish skin boots to travel with like this."
    },
    "92": {
        "startTime": 831.584,
        "endTime": 836.434,
        "transcript": "Makut cali angutait cali upluteng.",
        "translation": "Their men would also prepare."
    },
    "93": {
        "startTime": 837.915,
        "endTime": 846.465,
        "transcript": "Imkunek can'giircuutnek cali tamakut pinriata imkut taluyarpagnek pitullrit",
        "translation": "When they stopped using those traps for black fish, what they called large fish traps"
    },
    "94": {
        "startTime": 846.709,
        "endTime": 856.834,
        "transcript": "Makunek maa-i can'giirnek cali cimiqata'arqamegteki",
        "translation": "When they were going to change them from the blackfish [traps]"
    },
    "95": {
        "startTime": 856.953,
        "endTime": 865.665,
        "transcript": "Nutaan tamakunek call' taluyiluteng pitullruut.",
        "translation": "They would also then make those fish traps."
    },
    "96": {
        "startTime": 869.778,
        "endTime": 876.241,
        "transcript": "Tua-i-llu nutaan cali civcimariitki",
        "translation": "Then when they started setting them"
    },
    "97": {
        "startTime": 876.853,
        "endTime": 890.541,
        "transcript": "Maa-i mat'um nalliini canek can'giiret waten assigtalaraput piciatun, yaassiillernek missuullernek-llu.",
        "translation": "These days, we temporarily store blackfish in various things, old boxes and burlap bags."
    },
    "98": {
        "startTime": 891.016,
        "endTime": 900.179,
        "transcript": "Tau͡gken au͡gkut murilkellrenka anglicartelput tamakunek pikaitellruut.",
        "translation": "However, the ones I observed that raised us didn't have those."
    },
    "99": {
        "startTime": 900.779,
        "endTime": 913.566,
        "transcript": "Makut maa-i arnait cali tamakunek canegnek caqukaitnek uptetullruut.",
        "translation": "Their women would also prepare containers for them out of grass."
    },
    "100": {
        "startTime": 913.579,
        "endTime": 924.029,
        "transcript": "Waten tua-i cungakvaunrirqata qakingaqaki amlleriluki waten quyurrluki.",
        "translation": "When they're no longer green like this but become pale, they would gather a lot like this."
    },
    "101": {
        "startTime": 927.598,
        "endTime": 934.648,
        "transcript": "Cali-llu waten kiagmi, kituriqalliniunga.",
        "translation": "And in the summer like this, I forgot something."
    },
    "102": {
        "startTime": 934.867,
        "endTime": 947.63,
        "transcript": "Uptelallruit arnat tamakut pikameggnek, tamakut can'get kelugkaitnek, kelugkaitnek-wa tua-i pissuutekaitnek.",
        "translation": "Their women would prepare those that they would use, the coarse grass that they would use for stitches and other things."
    },
    "103": {
        "startTime": 949.842,
        "endTime": 961.855,
        "transcript": "Au͡gkut anglicartelput ingna tekitarkaq waten umyuaqerrlainarluku pitullruut.",
        "translation": "Those who raised us back then always had the future in mind like this."
    },
    "104": {
        "startTime": 961.867,
        "endTime": 971.48,
        "transcript": "Ingna tekitarkaq atu'urkateng yaaqsingraan upyuterrlainarluteng, camek-wa tua-i piilameng.",
        "translation": "They would always prepare what they needed in the future even if it was far because they didn't have anything."
    },
    "105": {
        "startTime": 971.492,
        "endTime": 978.892,
        "transcript": "Maani tau͡gaam makunek nunam qainganelngurnek aklungqellruut.",
        "translation": "What they had was only made from what was on the land."
    },
    "106": {
        "startTime": 980.386,
        "endTime": 985.811,
        "transcript": "Tua-i pinricunaunateng tamakut ellaitni piaqluteng.",
        "translation": "To them, they couldn't afford not to do that."
    },
    "107": {
        "startTime": 987.492,
        "endTime": 995.367,
        "transcript": "Una tua-i tekitarkaurtaqan pissuutekaa una yaaqsigluku amna upyutaqluki.",
        "translation": "They would prepare what they would need way ahead of time."
    },
    "108": {
        "startTime": 995.748,
        "endTime": 1004.186,
        "transcript": "Kiagmi maa-i iitaat can'get kelugkaqluki pitullruit.",
        "translation": "In the summer, they would use tall cottongrass for stitching."
    },
    "109": {
        "startTime": 1004.261,
        "endTime": 1015.836,
        "transcript": "Arnat iitartaangaqameng tamakunek tua-i-llu nutaan saggluki waten apeqmeggnek nalacirluki.",
        "translation": "When the women started gathering tall cottongrass, they would spread them out to dry them, as they called it."
    },
    "110": {
        "startTime": 1016.005,
        "endTime": 1029.817,
        "transcript": "Tua-i-llu nutaan tamakunek piameng apeqmeggnek naliita kinraki quyurtevkenaki-am cali tupigturluki.",
        "translation": "Then when they had, as they called it, dried out, they wouldn't gather them but weave them."
    },
    "111": {
        "startTime": 1031.155,
        "endTime": 1034.043,
        "transcript": "Nutaan-llu taqngamegteki imegluki.",
        "translation": "Then when they were done, they rolled them up."
    },
    "112": {
        "startTime": 1034.056,
        "endTime": 1039.906,
        "transcript": "Tuaten pitullruit tamakut can'get kelugkait.",
        "translation": "That's what they did with the grass they'd use for stitching."
    },
    "113": {
        "startTime": 1041.013,
        "endTime": 1055.125,
        "transcript": "Au͡gkut ava-i wangkuta mat'um nalliini-w' tua-i umyuaqaqamki tua-i wiinga-llu tamana atullerkaa capeqsagulluku.",
        "translation": "When I remember those during our time, I also find it difficult to do it."
    },
    "114": {
        "startTime": 1057.488,
        "endTime": 1062.363,
        "transcript": "Tua-i-llu nutaan cali makut angutait",
        "translation": "And then their men"
    },
    "115": {
        "startTime": 1065.107,
        "endTime": 1078.007,
        "transcript": "Makunek cali pissuutekameggnek makunek imarmiutarcuutekameggnek taluyinaurtut.",
        "translation": "They would make these tools, fish trap-like traps to catch minks."
    },
    "116": {
        "startTime": 1079.114,
        "endTime": 1089.514,
        "transcript": "Mikluki tua-i, qaill' waten taktaurluki, qaillun-llu tua-i waten kuiggaat-wa tua-i cuqluki taluyitullruut.",
        "translation": "They would make fish traps small, about this long, and a certain size after measuring the streams."
    },
    "117": {
        "startTime": 1090.508,
        "endTime": 1096.758,
        "transcript": "Tamakut-am cali piciatun pivkenateng cuqerluteng cali.",
        "translation": "Those were also not made without a process, but had measurements."
    },
    "118": {
        "startTime": 1096.777,
        "endTime": 1103.515,
        "transcript": "Makut-llu cali ilulirait waten can'giircuutetun ayuqevkenateng.",
        "translation": "Their inner components would not be like this like a blackfish trap."
    },
    "119": {
        "startTime": 1103.665,
        "endTime": 1111.028,
        "transcript": "Waten pinaurtut, tua-i-llu ingna igtetun ayquqeqerluni.",
        "translation": "They would be like this, and this over there would be like a den."
    },
    "120": {
        "startTime": 1113.14,
        "endTime": 1123.778,
        "transcript": "Au͡gna-wa alqerma uinga tayima waten tangvaurarqamni",
        "translation": "When I watched my older sister's husband like this back then"
    },
    "121": {
        "startTime": 1123.966,
        "endTime": 1136.141,
        "transcript": "Unatni tua-i waten piqerluki tauna tua-i cuq'errluku iteryararkaa, wagg'uq igyaraa piqa'aqluku.",
        "translation": "He would do this with his hands, and measure the entrance, what they call the igyaraq."
    },
    "122": {
        "startTime": 1136.16,
        "endTime": 1141.135,
        "transcript": "Tuaten ayuqetullruut piciatun pivkenateng.",
        "translation": "That's what they were like, not made without a process."
    },
    "123": {
        "startTime": 1141.279,
        "endTime": 1153.016,
        "transcript": "Tuamtellu cali cuignilngurcuutnek cali taluyiami tuamtellu igyarait waten ayuqluki au͡g'utun.",
        "translation": "Then when he made fish trap-like traps for land otters, he would make the entrances like that."
    },
    "124": {
        "startTime": 1153.141,
        "endTime": 1163.041,
        "transcript": "Tua-i-llu waten unatni cuq'errluku uumek kumluminek waten elliurluki neqututacirkiurluki.",
        "translation": "Then he would measure with his hand like this, doing this with his thumb to measure their width."
    },
    "125": {
        "startTime": 1163.585,
        "endTime": 1172.485,
        "transcript": "Tuaten piciatun-am cali pivkenateng tamakut pitullrulliniut.",
        "translation": "Those would also not be made without a process."
    },
    "126": {
        "startTime": 1174.317,
        "endTime": 1187.129,
        "transcript": "Tua-i mat'um nalliini-w' tua-i umyuaqaqamki au͡gkut qaill'-wa tua-i yuullruciit",
        "translation": "These days, when I remember how they used to live back then"
    },
    "127": {
        "startTime": 1187.742,
        "endTime": 1197.405,
        "transcript": "Piut, umyuaqaqamki caperqetullruanka.",
        "translation": "You know, when I remember them, I would feel like they had difficult lives."
    },
    "128": {
        "startTime": 1197.517,
        "endTime": 1212.38,
        "transcript": "Tau͡gaam wiinga-w' tua-i Kass'angluki pillruama makut maa-i aulukesteput Kass'artaatullruut.",
        "translation": "But since I [grew up] when after Westernization, our caretakers lived with some Western things."
    },
    "129": {
        "startTime": 1213.805,
        "endTime": 1219.592,
        "transcript": "Tau͡gaam carugarnek unangeksaunateng.",
        "translation": "But they didn't get a lot of [Western] things."
    },
    "130": {
        "startTime": 1219.605,
        "endTime": 1233.342,
        "transcript": "Makut maa-i saayut, mukaaq, saarralaq, caqapigtaqameng-llu sugg'alinek cali piaqluteng.",
        "translation": "They had these things, tea, floud, sugar, and once in a while, pilot bread."
    },
    "131": {
        "startTime": 1234.342,
        "endTime": 1248.992,
        "transcript": "Tamakut tau͡gken tua-i unakek'ngait tua-i itrutaqaceteng tepsaqnaurtut tua-i cakneq.",
        "translation": "However, when they brought in whatever they got, they would smell very strong."
    },
    "132": {
        "startTime": 1249.011,
        "endTime": 1253.499,
        "transcript": "Imkut-llu makut mat'um nalliini tepailnguut.",
        "translation": "These days, those don't smell like anything."
    },
    "133": {
        "startTime": 1253.512,
        "endTime": 1264.412,
        "transcript": "Sugg'alit antaqaceteng yaaqsigluteng tepsaqnaurtut, narniqpiarluteng assirluteng.",
        "translation": "When they took out pilot bread, they would smell strong from afar, they smelled nice and good."
    },
    "134": {
        "startTime": 1266.069,
        "endTime": 1271.994,
        "transcript": "Maa-i mat'um nalliini waten caciirulluki wiinga piunga.",
        "translation": "These days, I don't notice them anymore."
    },
    "135": {
        "startTime": 1272.0,
        "endTime": 1277.475,
        "transcript": "Caqa'arqama tau͡gaam nar'aqluki tua-i canimetaqata.",
        "translation": "But once in a while, I smell them when they're close."
    },
    "136": {
        "startTime": 1279.294,
        "endTime": 1283.831,
        "transcript": "Au͡gkut ava-i tuaten ayuqellruut.",
        "translation": "That's what those were like."
    },
    "137": {
        "startTime": 1284.894,
        "endTime": 1293.156,
        "transcript": "Qaillun-mi uksuarmi iciw' waten ayagaqata iciw' inerquutek'lallrit angutet?",
        "translation": "What about the admonishments they had for men, you know, when they traveled in the fall like this?"
    },
    "138": {
        "startTime": 1293.169,
        "endTime": 1299.194,
        "transcript": "Tua-llu, ii-i, waten ayagaaqameng",
        "translation": "So, yes, when they traveled like this"
    },
    "139": {
        "startTime": 1301.563,
        "endTime": 1309.625,
        "transcript": "Inerquutektullruit waten aarnarqellrani.",
        "translation": "They would admonish them when it was dangerous like this."
    },
    "140": {
        "startTime": 1309.938,
        "endTime": 1320.026,
        "transcript": "Neplirasqevkenaki-llu cali yuilqumi pitullruit. Waten neplirasqevkenaki.",
        "translation": "They also told them not to make too much noise in the wilderness. They told them not to make too much noise like this."
    },
    "141": {
        "startTime": 1320.039,
        "endTime": 1333.651,
        "transcript": "Tau͡gaam imkut arenqiallugtellriit, tamaa-i tamakut kiskuneng tua-i nepliraarkauluteng.",
        "translation": "Only those who've gotten into accidents, they will make a lot of noise if they fall into water."
    },
    "142": {
        "startTime": 1333.664,
        "endTime": 1345.414,
        "transcript": "Inerquutekluki-am cali tamakut waten uksuarmi yuilqumi aarasqevkenata, neplirasqevkenata.",
        "translation": "They also admonished us in the fall like this not to scream or make too much noise in the wilderness."
    },
    "143": {
        "startTime": 1348.671,
        "endTime": 1356.733,
        "transcript": "Tamakut-gguq tamaa-i tau͡gaam nanikualriit tuaten nepliratullruut.",
        "translation": "They said that only those who were helpless would make noise like that."
    },
    "144": {
        "startTime": 1356.746,
        "endTime": 1369.659,
        "transcript": "Tua-i-llu neplilriamek aaralriamek niiskuneng tua-i tauna taringerkauluku arenqiallugucia wall'u kis'ucia.",
        "translation": "Then if they hear someone making noise or screaming, they would understand that he got into an accident or sunk into water."
    },
    "145": {
        "startTime": 1371.084,
        "endTime": 1386.246,
        "transcript": "Tau͡gken mat'um nalliini tua-i inerquumananriameng-wa tua-i, inerqurnanriamceci wangkuta",
        "translation": "These days, however, since they are no longer admonished, since we no longer admonish you"
    },
    "146": {
        "startTime": 1386.897,
        "endTime": 1389.022,
        "transcript": "Caciirulluteng.",
        "translation": "They don't know how to act anymore."
    },
    "147": {
        "startTime": 1389.066,
        "endTime": 1399.966,
        "transcript": "Waten-llu neplianaurtut aaraaqluteng tua-i nunat akuliitni.",
        "translation": "They also make a lot of noise and scream between villages."
    },
    "148": {
        "startTime": 1400.66,
        "endTime": 1403.948,
        "transcript": "Inerquutektullruit.",
        "translation": "They admonished against that."
    },
    "149": {
        "startTime": 1404.286,
        "endTime": 1415.136,
        "transcript": "Tua-i-llu ataucirqumek wiinga atullruaqa tamana arenqiallugtellria niitellemni.",
        "translation": "So, I experienced that one time when I heard someone who had gotten into an accident."
    },
    "150": {
        "startTime": 1416.13,
        "endTime": 1425.155,
        "transcript": "Ukut, ukut nunauruyuciat Tuntutuliarmiut akaurpailgan",
        "translation": "Not long after Tuntutuliak was established as a village"
    },
    "151": {
        "startTime": 1427.586,
        "endTime": 1434.486,
        "transcript": "Kellirni kanani uitallemteńi, ukut-wa keluqliput cali.",
        "translation": "When we were in Kelliq down there, and there were people upriver too."
    },
    "152": {
        "startTime": 1435.48,
        "endTime": 1441.28,
        "transcript": "Una waniwa nanvaq mat'um enem ketiini tangraan.",
        "translation": "You see this lake toward the water from this house."
    },
    "153": {
        "startTime": 1442.462,
        "endTime": 1452.962,
        "transcript": "Waten erenrani atakuyartumi maaken kelumteńek aaralria, qang'a-ll' pingkuuyukanka.",
        "translation": "In the day like this toward the evening, someone was screaming inland from us, and I thought it was our inland neighbors."
    },
    "154": {
        "startTime": 1453.606,
        "endTime": 1458.569,
        "transcript": "Cunaw' tua-i kit'ellria kanani, kicaaqellinill'.",
        "translation": "It turned out he had fallen into the water down there."
    },
    "155": {
        "startTime": 1458.856,
        "endTime": 1473.531,
        "transcript": "Qerruniaranrakun iliita atralriit tanglliniluku man'a waten nunataitellrani.",
        "translation": "One of the people going down saw him just as he was about to freeze when there was no village like this."
    },
    "156": {
        "startTime": 1474.912,
        "endTime": 1481.562,
        "transcript": "Cat inerquutait au͡gkut amllellruut.",
        "translation": "The people back then had a lot of admonishments."
    },
    "157": {
        "startTime": 1481.656,
        "endTime": 1488.419,
        "transcript": "Waten au͡g'umek ava-i neplirasqevkenaki pitullruluki.",
        "translation": "They would tell them not to make noise like this."
    },
    "158": {
        "startTime": 1488.756,
        "endTime": 1497.019,
        "transcript": "Tua-i-llu nutaan waten cali ayakata'arqameng cali",
        "translation": "Then, when they were also going to travel like this"
    },
    "159": {
        "startTime": 1500.506,
        "endTime": 1508.544,
        "transcript": "Qanerrlainarluteng tamatum nuniinun ayakatarniluteng.",
        "translation": "They would always say where they were going to go."
    },
    "160": {
        "startTime": 1511.619,
        "endTime": 1526.094,
        "transcript": "Tua-i waten tekitenritaqata-llu tua-i arenqialluguciit nalluvkenaki piaqluki.",
        "translation": "When they wouldn't return like this, they would know that they had gotten into an accident."
    },
    "161": {
        "startTime": 1529.925,
        "endTime": 1540.3,
        "transcript": "Tau͡gken mat'um nalliini waten ayagaaqameng maa-i angyatgun qanerpek'nateng.",
        "translation": "When they travel with boats these days, however, they don't say anything."
    },
    "162": {
        "startTime": 1541.756,
        "endTime": 1551.394,
        "transcript": "Tua-i-llu tekitenrilameng, tekitenrilata qaill' tua-i ayuquciinaki qanenrilata.",
        "translation": "Then when they don't return, they don't know what happened because they didn't say anything."
    },
    "163": {
        "startTime": 1552.769,
        "endTime": 1558.419,
        "transcript": "Piciatun maa-i mat'um nalliini ayagangameng.",
        "translation": "It's because they don't consider before traveling these days."
    },
    "164": {
        "startTime": 1558.426,
        "endTime": 1565.901,
        "transcript": "Wall'u natetmurrnguarluteng nunanun-ll' allanun ayagaqluteng.",
        "translation": "Or they say they're going somewhere, then go to other villages."
    },
    "165": {
        "startTime": 1566.17,
        "endTime": 1573.207,
        "transcript": "Tamaa-i tamatum maa-i mat'um nalliini ayuquciirucetaitkut.",
        "translation": "That is what causes us confusion these days."
    },
    "166": {
        "startTime": 1574.345,
        "endTime": 1584.232,
        "transcript": "Qaillun tua-i ukut kingunrulriit waten ayuquciinaki piaqluki.",
        "translation": "We don't know what the next generation is doing."
    },
    "167": {
        "startTime": 1584.457,
        "endTime": 1587.495,
        "transcript": "Wall'u tuancukluki.",
        "translation": "Or we think they're somewhere [else]."
    },
    "168": {
        "startTime": 1588.108,
        "endTime": 1598.145,
        "transcript": "Maa-i mat'um nalliini yuilqumi-llu tua-i tuqungraata qaillun ayuquciitaqluki.",
        "translation": "These days, even if they die in the wilderness, we have no idea about them."
    },
    "169": {
        "startTime": 1600.958,
        "endTime": 1610.995,
        "transcript": "Tang tua-i mat'um nalliini tua-i-wa waten caknernarqellriit amlleriameng.",
        "translation": "You see, it's because there are not a lot of things that bring us struggle these days."
    },
    "170": {
        "startTime": 1613.783,
        "endTime": 1621.883,
        "transcript": "Maa-i waten au͡gkut ayuqellrunritut waten.",
        "translation": "Now, the people back then were not like this."
    },
    "171": {
        "startTime": 1622.102,
        "endTime": 1627.302,
        "transcript": "Tua-i ca murilkerrlainarluku.",
        "translation": "They always observed everything."
    },
    "172": {
        "startTime": 1627.321,
        "endTime": 1643.721,
        "transcript": "Uksuarmi-llu wangkuta cali tan'gaurlurni waten qalaruquratullruitkut ciunerkamteńek, tekitarkamteńek ellmeng atuqemeggnek.",
        "translation": "And in the fall, they would always speak to us boys about our future, what we would experience, things they had experienced."
    },
    "173": {
        "startTime": 1644.878,
        "endTime": 1650.078,
        "transcript": "Aarnarqellriit apertualuki yuilqumi-llu.",
        "translation": "They would explain dangerous things, in the wilderness too."
    },
    "174": {
        "startTime": 1652.897,
        "endTime": 1667.847,
        "transcript": "Cat, cat-llu maani nunam qaingani pengurraat qertuuralriit aterluteng, kuiggaat-llu tamarmeng aterluteng, nanvat-ll' ilait cali aterluteng.",
        "translation": "And everyhing on this land, elevated hills, had names, and all of the creeks had names, and some lakes had names."
    },
    "175": {
        "startTime": 1668.941,
        "endTime": 1675.041,
        "transcript": "Tua-i nalluvkenaku man'a nunam qainga.",
        "translation": "They knew they layout of the land."
    },
    "176": {
        "startTime": 1675.148,
        "endTime": 1689.235,
        "transcript": "Tau͡gken mat'um nalliini makut maa-i yup'ut apertuatnanriimteki mat'umek yuilqumek",
        "translation": "These days, however, since we are not pointing things out in the wilderness to our children anymore"
    },
    "177": {
        "startTime": 1689.273,
        "endTime": 1697.198,
        "transcript": "Cat-llu nallungluki, kuiget-llu, nanvat-llu, qertulriit-llu makut.",
        "translation": "They don't know anything, including these river, and lakes, and these elevated spots."
    },
    "178": {
        "startTime": 1701.654,
        "endTime": 1712.129,
        "transcript": "Camek-llu tua-i piaqata apcaaqellriani cam nuniini camek piciitnek",
        "translation": "And when they get something and are asked what area they got it from"
    },
    "179": {
        "startTime": 1712.273,
        "endTime": 1721.71,
        "transcript": "Wall'u yuk tauna waten maa-i mat'um nalliini tamarilalriit, tamalalriit.",
        "translation": "Or if they lose where a person is, or a person gets lost as they do these days."
    },
    "180": {
        "startTime": 1723.36,
        "endTime": 1736.885,
        "transcript": "Tauna, tauna tangertellra apcaaqellriani cam nuniini tangellrucianek atra-llu nalluluku.",
        "translation": "When they ask the person who saw him about the area he saw him, he doesn't know its name."
    },
    "181": {
        "startTime": 1736.891,
        "endTime": 1745.716,
        "transcript": "Taum-gguq avani-irluteng tau͡gaam pinaurtut apertuatnanriamceteng.",
        "translation": "They only say, \"Over there,\" because we don't point those out to them anymore."
    },
    "182": {
        "startTime": 1746.885,
        "endTime": 1754.997,
        "transcript": "Ca tamalkuan wangkuta qalaruyutek'lallruyaaqaput aturrlainarpek'naki tau͡gaam.",
        "translation": "We used to talk about everything, but we wouldn't always use them."
    },
    "183": {
        "startTime": 1755.385,
        "endTime": 1759.685,
        "transcript": "Tau͡gaam tekitaqamteki elitaqaqluki.",
        "translation": "But when we came upon them, we would recognize them."
    },
    "184": {
        "startTime": 1761.354,
        "endTime": 1770.192,
        "transcript": "Yaa, qanruyutekun tau͡gaam yuk yuugarkauyaaqelliniami.",
        "translation": "Yes, a person must only live according to the traditional wisdom."
    },
    "185": {
        "startTime": 1770.342,
        "endTime": 1782.867,
        "transcript": "Qanruyun atunrilkuniu elluarrluni yuungaitelliniuq, ilaminek-llu waten enuqlilluni calrianek.",
        "translation": "If he does not abide by traditional wisdom, he will not live right, and he will have need of the things his peers work for."
    },
    "186": {
        "startTime": 1784.823,
        "endTime": 1798.348,
        "transcript": "Waten au͡gkut qalarutetullruitkut: man'a-gguq qanruyun atuqumteggu maligtaquluku-llu yuukumta elluarrluta yuugarkaugukut",
        "translation": "They would talk to us like this back then: if we live using and abiding by this traditional wisdom, we will live well"
    },
    "187": {
        "startTime": 1798.379,
        "endTime": 1802.642,
        "transcript": "Qessalertevkenata, qavaarpek'nata.",
        "translation": "Not being lazy, not sleeping too much."
    },
    "188": {
        "startTime": 1806.317,
        "endTime": 1810.179,
        "transcript": "Tuaten tua-i akeqnauraitkut.",
        "translation": "They would promise us that."
    },
    "189": {
        "startTime": 1811.417,
        "endTime": 1822.617,
        "transcript": "Tau͡gken tua-i tamana apertuallrat tekiteksaunaku.",
        "translation": "However, we didn't come upon the time they pointed out."
    },
    "190": {
        "startTime": 1822.636,
        "endTime": 1828.099,
        "transcript": "Tau͡gaam tekitaqamteggu maa-i mat'um nalliini elitaqaqluku.",
        "translation": "But when we come upon them these days, we recognize it."
    },
    "191": {
        "startTime": 1828.511,
        "endTime": 1834.024,
        "transcript": "Taumek au͡gkut waten qalarut'lallrukaitkut:",
        "translation": "That's why they would talk to us like this back then:"
    },
    "192": {
        "startTime": 1835.211,
        "endTime": 1846.324,
        "transcript": "Una-gguq qalarutestevut murilkelluku tangvaurqilarput qanra.",
        "translation": "We should pay attention to someone who is talking to us and watch his mouth."
    },
    "193": {
        "startTime": 1847.336,
        "endTime": 1855.561,
        "transcript": "Atam-gguq uluqaqumteggu imna qalartellra uunguciirniartuq.",
        "translation": "They said that if we look away from him, we'll have no idea what he's talking about anymore."
    },
    "194": {
        "startTime": 1855.567,
        "endTime": 1857.442,
        "transcript": "Ilumun-llu...",
        "translation": "And indeed..."
    }
};